export default "__VITE_ASSET__DbWE15dR__"